import { useEffect, useState } from 'react';
import { Box, Grid2 as Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logger from '../../../utils/logger';
import { MainCard } from '../../../component/cards/MainCard2';
import { SelectionButton, SubmitButton } from '../../../component/buttons';
import { TabPanel } from '../../../component/tabPanel';
import { creatableUserTypes } from '../../../configs/users';
import HeaderCard from './HeaderUserAdd';
import PersonalBodyCard from './body/PersonalBodyCard';
import MedicalBodyCard from './body/MedicalBodyCard';
import { GroupSelector } from './body/GroupSelector';
import { gridSpacing } from 'store/constant';
import { useFormikAddUser } from 'hooks/useFormikAddUser';
import { getGroups } from 'services/groups';

function Users() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const location = useLocation();

    const preselectedRole = location.state?.preselectedType;
    const preselectedType =
        creatableUserTypes.find((type) => type.role === preselectedRole)?.value ?? 0;
    const formik = useFormikAddUser(preselectedType);
    const [tab, setTab] = useState(0);

    const [availableGroups, setAvailableGroups] = useState([]);

    const tabs =
        formik.values.type === 0
            ? [t('users.tabs.personalData'), t('users.tabs.medicalData')]
            : [t('users.tabs.personalData')];

    useEffect(() => setTab(0), [formik.values.type]);

    useEffect(() => {
        const fetchGroups = async () => {
            try {
                const res = await getGroups();
                setAvailableGroups(res);
            } catch (err) {
                Logger.error('Erro ao procurar grupos', err);
            }
        };
        fetchGroups();
    }, []);

    return (
        <MainCard title={t('users.newUser')}>
            <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={gridSpacing}>
                    <Grid size={12}>
                        <HeaderCard
                            values={formik.values}
                            handleChange={formik.handleChange}
                        />
                    </Grid>
                    <Grid container size={12}>
                        {tabs.map((tabName, index) => (
                            <Grid key={index} size={12 / tabs.length}>
                                <SelectionButton
                                    selected={tab === index}
                                    sx={{
                                        width: '100%',
                                        py: 2
                                    }}
                                    onClick={() => setTab(index)}
                                >
                                    {tabName}
                                </SelectionButton>
                            </Grid>
                        ))}
                    </Grid>
                    <Grid size={12}>
                        <TabPanel value={tab} index={0}>
                            <PersonalBodyCard formik={formik} />
                        </TabPanel>
                        {formik.values.type === 0 && (
                            <Box
                                role="tabpanel"
                                hidden={tab !== 1}
                                id="simple-tabpanel-1"
                                aria-labelledby="simple-tab-1"
                            >
                                <MedicalBodyCard formik={formik} />
                            </Box>
                        )}
                    </Grid>
                    <Grid
                        container
                        size={12}
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            mt: 2
                        }}
                    >
                        <GroupSelector
                            values={formik.values}
                            handleChange={formik.handleChange}
                            groups={availableGroups}
                            width={400}
                        />
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            <SubmitButton
                                type="button"
                                onClick={() => navigate('/users', { replace: true })}
                            >
                                {t('common.cancel')}
                            </SubmitButton>

                            <SubmitButton
                                disabled={formik.isSubmitting}
                                name="submit"
                                type="submit"
                            >
                                {t('common.save')}
                            </SubmitButton>
                        </Box>
                    </Grid>
                </Grid>
            </form>
        </MainCard>
    );
}

export default Users;
